const vacation = `Rakas Mika,
Toivon, että viihdyt Italiassa!
Halusin kertoa sinulle, että kissasi voi hyvin.
Olen käynyt joka päivä varmistamassa, että hänellä on kaikki mitä hän tarvitsee.
Kotisi on myös hyvässä kunnossa, joten sinun ei tarvitse huolehtia mistään.
Italia kuulostaa uskomattomalta, enkä malta odottaa, että pääsen kuulemaan kaikista seikkailuistasi, kun palaat.
Lyön vetoa, että ruoka siellä on aivan uskomatonta!
Tuo mukava matkamuisto Italiasta, kun tulet takaisin.
Halusin myös kertoa mielenkiintoisia uutisia.
Sain vihdoin viimeisteltyä olohuoneeni remontin, ja se näyttää upealta!
En malta odottaa, että tulet katsomaan sitä.
Pidä huolta ja nauti loppulomastasi!
Parhaat`;

export default vacation;